var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index"},[(!_vm.errorMsg)?_c('van-loading',{attrs:{"size":"40","vertical":""}},[_vm._v("加载中...")]):_c('van-empty',{attrs:{"image":"error","description":_vm.errorMsg}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }